"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var index_1 = require("../index");
exports.CubeAPI = {
    getQuery: function (companyId, query, baseRequestId, spanCounter) {
        var headers = {};
        if (baseRequestId && spanCounter) {
            var requestId = baseRequestId + "-span-" + spanCounter;
            headers = {
                'x-request-id': requestId,
            };
        }
        return index_1.axios.post("/api/v1/company/" + companyId + "/cube/load/", query, {
            timeout: 100000,
            headers: headers,
        }).then(function (response) { return response; });
    },
};
//# sourceMappingURL=CubeAPI.js.map